import { gql } from '@apollo/client'

export const RESOURCE_CREATE_MUTATION = gql`
  mutation RESOURCE_CREATE_MUTATION($input: PlanObjectiveResourceInput!) {
    planObjectiveResourceCreate(input: $input) {
      ok
    }
  }
`

export const RESOURCE_UPDATE_MUTATION = gql`
  mutation RESOURCE_UPDATE_MUTATION($id: ID!, $input: PlanObjectiveResourceInput!) {
    planObjectiveResourceUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const RESOURCE_DELETE_MUTATION = gql`
  mutation RESOURCE_DELETE_MUTATION($id: ID!) {
    planObjectiveResourceDelete(id: $id) {
      ok
    }
  }
`
